export const siteData = {
  assetsUnderManagement: '£125M+',
  investmentProperties: '120+',
  yearsExperience: '25+',
  totalPortfolioValue: '£125M+',
  activeInvestments: '65+',
  averageAnnualReturn: '15%',
  clientSatisfaction: '100%',
  stats: {
    totalPortfolioValue: '£125M+',
    activeInvestments: '65+',
    averageAnnualReturn: '15%',
  },
};
